// pages/LandingPage.jsx
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import Header from "components/Navigation/Header";
import Meta from "components/Meta";

function ContactLandingPage() {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [referralCode, setReferralCode] = useState(null);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) setReferralCode(ref);
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get("name");
    const email = formData.get("email");
    const company = formData.get("company");
    const message = formData.get("message");

    setLoading(true);

    try {
      const response = await makeApiRequest(
        "post",
        apiRoutes.contactUs,
        null,
        null,
        {
          name,
          email,
          company,
          message,
          referralCode,
        }
      );

      if (response.status === 200) {
        setSubmitted(true);
        e.target.reset();
      } else {
        window.alert(
          "There was an issue submitting your message. Please try again."
        );
      }
    } catch (error) {
      console.error(error);
      window.alert(
        "There was an error submitting the form. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Meta title="Sound Commerce | A full-suite global payments consultancy." />
      <div className="dark animated-gradient min-h-screen flex flex-col">
        <Header />
        {/* Flex-grow wrapper ensures the section fills remaining viewport height */}
        <main className="flex-grow flex items-center justify-center bg-background text-foreground font-jakarta font-light px-6 md:px-[75px]">
          <section className="w-full max-w-2xl text-left">
            <h1 className="text-4xl md:text-5xl leading-tight mb-3">
              Optimize Your Payments Strategy
              <span className="text-brand">.</span>
            </h1>
            <h2 className="font-normal text-base md:text-lg mb-6">
              Let us know what you need help with, and we’ll get in touch with
              you soon.
            </h2>

            {submitted ? (
              <div className="text-green-400 text-lg">
                Thanks! We'll be in touch soon.
              </div>
            ) : (
              <form className="space-y-4" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="name" className="block mb-1 text-sm">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    className="w-full px-3 py-2 rounded-md bg-card border border-border focus:outline-none focus:ring-2 focus:ring-brand"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block mb-1 text-sm">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-3 py-2 rounded-md bg-card border border-border focus:outline-none focus:ring-2 focus:ring-brand"
                  />
                </div>

                <div>
                  <label htmlFor="company" className="block mb-1 text-sm">
                    Company
                  </label>
                  <input
                    type="text"
                    name="company"
                    className="w-full px-3 py-2 rounded-md bg-card border border-border focus:outline-none focus:ring-2 focus:ring-brand"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block mb-1 text-sm">
                    Message
                  </label>
                  <textarea
                    name="message"
                    rows="3" // ✅ reduced rows so it doesn’t push below the fold
                    required
                    className="w-full px-3 py-2 rounded-md bg-card border border-border focus:outline-none focus:ring-2 focus:ring-brand resize-none"
                  />
                </div>

                {referralCode && (
                  <input
                    type="hidden"
                    name="referralCode"
                    value={referralCode}
                  />
                )}

                <div className="flex items-center gap-2 pt-2">
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-5 py-2 bg-brand text-background text-sm font-semibold rounded-lg hover:bg-brand-400 transition disabled:opacity-50"
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            )}
          </section>
        </main>
      </div>
    </>
  );
}

export default ContactLandingPage;
